// Canonical daytime values stay independent of the device clock and UI language.
const EXPECTED_START_TIMES = [
    "10:30", "11:15", "11:30", "12:00", "12:30", "13:00",
    "13:30", "14:00", "14:45", "16:00", "16:30",
];

export const getExpectedStartTimeOptions = () => [...EXPECTED_START_TIMES];

export const formatExpectedStartTimeOption = (value, language = "en") => {
    if (!value) return "—";
    const normalized = normalizeExpectedStartTime(value);
    // Historical off-list times retain their unambiguous 24-hour labels.
    const label = EXPECTED_START_TIMES.includes(normalized)
        ? `${String(Number(normalized.slice(0, 2)) % 12 || 12).padStart(2, "0")}:${normalized.slice(3)}`
        : normalized;
    return /^ar(?:-|$)/i.test(language)
        ? label.replace(/[0-9]/g, digit => "٠١٢٣٤٥٦٧٨٩"[Number(digit)])
        : label;
};

export const resolveExpectedStartTime = (value, original) =>
    value === normalizeExpectedStartTime(original) ? (original || "") : (value || "");

export const normalizeExpectedStartTime = (value) => {
    if (!value) return "";
    const [hour, minute] = String(value).split(":");
    return `${hour.padStart(2, "0")}:${minute}`;
};
